import * as moment from 'moment';
import {Injectable} from '@angular/core';
import {AppConfig} from '../../../config/app.config';
import { BuildingContactFunction } from '../model/building-contact-function';

@Injectable()
export class DateService {

  constructor(private appConfig: AppConfig) {
  }

  public convertFunctionDatesToUniversalDate(payload: any) {
    const buildingFunction: BuildingContactFunction = Object.assign({}, payload.function);
    if (buildingFunction.from !== '') {
      buildingFunction.from = this.convertLocalToUTC(buildingFunction.from);
    }
    if (buildingFunction.to !== '') {
      buildingFunction.to = this.convertLocalToUTC(buildingFunction.to);
    }
    payload.function = buildingFunction;
  }

  public convertUTCToLocal(value: string): string {
    return moment.utc(value).local().format();
  }

  public formatForDatePicker(value): string {
    return moment(value).format(this.appConfig.MOMENT_DATE_FORMAT);
  }

  public formatToDateTimeFormat(value): string {
    return moment(value).format(this.appConfig.MOMENT_DATE_TIME_FORMAT);
  }

  public formatToDateFormat(value): string {
    return moment(value).format(this.appConfig.MOMENT_DATE_FORMAT);
  }

  public formatFromDatePickerToLocal(value, time: string = null): string {
    const date = moment(value, this.appConfig.MOMENT_DATE_FORMAT).local();
    if (time) {
      const timeArray = time.split(':');
      date.hour((timeArray[0].charAt(0) === '0') ? parseInt(timeArray[0].charAt(1), 10) : parseInt(timeArray[0], 10));
      date.minutes((timeArray[1].charAt(0) === '0') ? parseInt(timeArray[1].charAt(1), 10) : parseInt(timeArray[1], 10));
    }
    return date.format();
  }

  public convertLocalToUTC(value: string): string {
    const local = moment(value);
    if (local.hour() === 0) {
      local.hour(12);
    }
    return moment.utc(local).format();
  }
}
